import { FEATURE_FLAGS } from "data/ss-data-store";

export function flagCheck(flag: string) {
  return !!FEATURE_FLAGS[flag];
}

export const useFlags = () => {
  return FEATURE_FLAGS;
};
